// important - has to use LOAD - as shogun seems to add in code after dom loaded
// to get route on the page to grab - add this to theme.liquid up near the top: <div class="route">{{ routes.root_url }}</div>
// wrap an element you wish to scan with a div with a class of : shop-path-check
// andy@blink 27/03/23

window.addEventListener('load', () => {
   
  // Get the root url from the element with the class "route"
  let { textContent: strippedRoute } = document.querySelector('.route');

  // Remove the slash if the root url is empty
  if (strippedRoute === '/') {
    strippedRoute = '';
  }
  
  // Find all links inside the div with the class "shop-path-check"
  document.querySelectorAll('.shop-path-check a').forEach(link => {
    // If the link's href contains "/products"
    if (link.href.includes('/products')) {
      // Replace "/products" with "/en-gb/products"
      link.href = link.href.replace('/products', `${strippedRoute}/products`);
    }
    // If the link's href contains "/collections"
    if (link.href.includes('/collections')) {
      // Replace "/collections" with "/en-gb/collections"
      link.href = link.href.replace('/collections', `${strippedRoute}/collections`);
    }
  });
});